import _parseUrl from 'url-lib/parseUrl';
import memoize from 'lodash/memoize';

const parseUrl = memoize(_parseUrl);
const DOMAIN_REGEX = /(.+)\.(.+)/;

export const _isProtocolValid = (value) =>
    value === 'http:' || value === 'https:';
export const _isHostValid = (value) => value.match(DOMAIN_REGEX);

export const isValidUrl = (value) => {
    const url = parseUrl(value);

    return Boolean(
        _isProtocolValid(url.protocol) && url.host && _isHostValid(url.host),
    );
};

export const isValidUrlNoProtocol = (value) => {
    const url = parseUrl(value);

    return Boolean(
        (url.protocol === '' || _isProtocolValid(url.protocol)) &&
            _isHostValid(url.href),
    );
};
